import { API } from "aws-amplify";
import axios from 'axios';
import "containers/common/List.css";
import React, { Component } from "react";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactTable from "react-table";
import 'react-table/react-table.css';
import { s3GetFolderFiles, s3GetURL, s3Upload, s3Delete } from "lib/awsLib";
import Select from 'react-select';
import { PacmanLoader } from 'react-spinners';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class WalkCopyList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            walkcopies: [],
            filter: {},
            showAlert: false,
            showWarning: false,
            errorMessage: "",
            savingNewRecord: false,
            
            selectedCityscope: null,
            cityscope: null
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleGenerate = this.handleGenerate.bind(this);
    }
    

    async componentDidMount() {
        console.log("In WalkCopyList componentDidMount");
        this.setState({ isLoading: true });      
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        const cityscopeOptions = await this.getCityscopes();
        if (cityscopeOptions) {     
            this.setState(state => ({ cityscopeOptions }));
        }

        document.title = "Cityscope Property Search";
        this.setState({ isLoading: false });      
    }

    
    componentWillUnmount() {
        source.cancel();
        
        
        this.setState({ walkcopies: [] });        
    }


    
    async getWalkCopies(cityscope) {
        console.log("Inside getWalkCopies() ");
        
        // return API.get("colin", "/walkcopies", {'queryStringParameters': filter});
        let files = [];
        if(cityscope){
            try{
                    await s3GetFolderFiles('WalkCopyPDF/'+cityscope+"", "").then(async s3files => {
                        console.log("First search"+s3files);
                        if(s3files){
                            console.log("In the first if");
                            for (var i = 0; i < s3files.length; i++) {
                                let url = await s3GetURL(s3files[i].key, null);
                                if (s3files[i].key!=="assets/") {
                                    files.push({ key: s3files[i].key.replace(`WalkCopyPDF/${cityscope}/`,""), url: url, lastModified: String(s3files[i].lastModified) });
                                }
                            }
                            // files.sort(function (a, b) {return  a.key.localeCompare(b.key)});
                            this.setState({ walkcopies: files.reverse()});
                            
                            return true;
                        }                            
                        
                    }
                    );
            }
            catch(e){
                console.log(e.message);
            }
        }
      
    }

    async getCityscopes() {
        return API.get("colin", `/cityscopes/dropdown`);                
    }

    handleChange = event => {
        console.log("Inside handleChange");
        this.setState({
            [event.target.id]: event.target.value
        });
        
    }

    handleCityscopeChange = async (selectedCityscope) => {
        if (selectedCityscope){
            this.setState({ selectedCityscope
                ,cityscope: selectedCityscope.value
                , modified: true },this.handleBlur)
        }else{
            this.setState(state => ({ selectedCityscope }));
            this.setState(state => ({ cityscope: null }));
        }
        
        
    }

    async handleSubmit(event) {
        
        event.preventDefault();
        this.setState({ isLoading: true });
        
        const result = await this.getWalkCopies(this.state.cityscope);

        

        this.setState({ isLoading: false });
                
     }

    async generateWalkCopies(cityscope) {
        
        await API.post("colin", `/walkcopy/${cityscope}`, { body: {} }).then(response => {
            return true;
          })
          .catch(error => {
            console.log(error.response);
            
          });   
       
    }

     async handleGenerate(event){
        event.preventDefault();
        let confirmed = window.confirm(`Are you sure you want to generate a Walk Copy for ${this.state.cityscope} Cityscope?`);
            if (confirmed) {
                    this.setState({ isLoading: true });
                    const result = this.generateWalkCopies(  this.state.cityscope);
                    window.alert("Your request to generate a walk copy has been confirmed! Your walk copy will be generated on the Server and should be available for download within 10 minutes. Please come back to this screen at a later time and click [Search] to view and download you walk copy (zip).")
                    this.setState({ isLoading: false });
            }
     }


    renderEditable = cellInfo => {
        const cellValue = this.state.walkcopies[cellInfo.index][cellInfo.column.id];


        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }
        }
    }

    
    
    
    
      
    
    renderTable(data) {
        const columns = [

            {
                id: 'file',
                Header: 'File',            
                accessor: 'key',
                maxWidth: 250,
                Cell: e => <a download target="_blank" href={`${e.original.url}`} > {e.value} </a>
                

            }
            , {
                Header: 'Created Date',            
                accessor: 'lastModified',
                maxWidth: 150,
                

            }
           
        ]          

        if (!data) {
            return null
        }
        else {
            
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={30}
                    sortable={true}
                />
            )
        }
    }

    renderPacman(){
        return (
            <div className="outer-div"><div className='sweet-loading inner-div' >
                <PacmanLoader
                    css="display: block;
                    margin: 0 auto;
                     border-color: red"
                sizeUnit={"px"}
                size={20}
                color={'#e03c31'}
                loading={this.state.isLoading}
                />
        </div>
            </div>);
    }

    renderComponent() {
        return (
            <div className="walkcopies">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                {this.state.showWarning &&
                                <Alert variant="danger">{this.state.errorMessage}</Alert>
                            }
                <Form onSubmit={this.handleSubmit}>
                    <Form.Row >
                        
                        <Col lg={2}>
                        <Form.Group controlId="cityscope" >                        
                                <Select
                                    value={this.state.selectedCityscope}
                                    onChange={this.handleCityscopeChange}
                                    options={this.state.cityscopeOptions}
                                    placeholder="Cityscope"
                                    isClearable
                                   
                                />
                                </Form.Group>
                        </Col>                        
                        <Col lg={2}>
                        {this.state.selectedCityscope && <Button type="submit"  onClick={this.handleSubmit}   className="float-left">Search</Button>}
                        {this.state.selectedCityscope && <Button type="button"  variant="primary"  onClick={this.handleGenerate}  className="float-right">Generate</Button>}
                        </Col>                                               
                    </Form.Row>
                </Form>
                        
               

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                     
                        {!this.state.isLoading ? this.renderTable(this.state.walkcopies) : this.renderPacman()  }
                        </Col>
                    </Row>
           

            </div>
        );
    }
  render() {
    return (

        <div className="WalkCopuList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            
        </div>
    );
  }
}
